import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestApi } from '../RestApi/restApi';
import { Observable } from 'rxjs';



interface deviationInfo {   
  statusMessage: any;
  error: boolean;
  data: any[];
}

interface RootCause {
  rootCauseName: string;
  causeType?: string;
  category?: string;
  subCategory?: string;
  rootCauseDescription?: string;
  rootCauseAnalysis?: string;
  rootCauseAnalysisType?: string;
}

 interface Capa {
  capaName: string;
  capaDescription: string;
  actionType:string
}

@Injectable({
  providedIn: 'root'
})

export class DeviationService {

    private headers = new HttpHeaders({
      "Content-Type": "application/json"
      });
  
      private headerpart = new HttpHeaders({
        'enctype': 'multipart/form-data',  // Ensure the correct encoding
      });
  

  constructor( private restApi: RestApi,private http: HttpClient,) { }

  private buildUrl(url: string, params: Record<string, any>): string {
  Object.keys(params).forEach(key => {
    url = url.replace(`{${key}}`, params[key]);
  });
  return url;
}

  createDeviation(workspaceId: string,dnsId: string,deviationFor: string,uniqueRecordId: string,payload: any): 
  Observable<deviationInfo> {
    const url = this.buildUrl(this.restApi.CREATE_DEVIATION, {
      workspaceId,
      dnsId,
      deviationFor,
      uniqueRecordId
    });

    return this.http.post<deviationInfo>(url, payload ,{ headers: this.headers });
  }

    getAllActiveDeviations(): Observable<any[]> {
    return this.http.get<any[]>(
      this.restApi.GET_ALL_ACTIVE_DEVIATION ,{ headers: this.headers }
    );
  }

   getDeviationById(id: number): Observable<any> {
    const url = this.buildUrl(this.restApi.GET_DEVIATION_DETAILS_BY_ID, { id });
    return this.http.get<any>(url,{ headers: this.headers });
  }

  updateDeviation(id: any, payload: any): Observable<deviationInfo> {
    const url = this.buildUrl(this.restApi.UPDATE_DEVIATION, { id });
    return this.http.post<deviationInfo>(url, payload,{ headers: this.headers });
  }

  closeDeviation(id: any): Observable<deviationInfo> {
    const url = this.buildUrl(this.restApi.CLOSE_DEVIATION, { id });
    return this.http.post<deviationInfo>(url, {},{ headers: this.headers });
  }

  softDeleteDeviation(id: number): Observable<deviationInfo> {
    const url = this.buildUrl(this.restApi.SOFT_DELETE_DEVIATION, { id });
    return this.http.post<deviationInfo>(url, {},{ headers: this.headers });
  }

  deleteDeviationById(deviationId: number): Observable<deviationInfo> {
    const url = this.buildUrl(this.restApi.DELETE_DEVIATION, { deviationId });
    return this.http.delete<deviationInfo>(url,{ headers: this.headers });
  }

  // ===================== ROOT CAUSE =====================

  getRootCauses(deviationId: any): Observable<RootCause[]> {
    const url = this.buildUrl(
      this.restApi.GET_ROOT_CAUSES_BY_DEVIATION_ID,
      { deviationId }
    );
    return this.http.get<RootCause[]>(url,{ headers: this.headers });
  }

  addRootCauses(
    deviationId: any,
    rootCauses: RootCause[]
  ): Observable<deviationInfo> {

    const url = this.buildUrl(
      this.restApi.ADD_ROOT_CAUSES,
      { deviationId }
    );

    return this.http.post<deviationInfo>(url, rootCauses,{ headers: this.headers });
  }

  updateRootCause(
    deviationId: number,
    rootCauseId: string,
    rootCause: RootCause
  ): Observable<deviationInfo> {

    const url = this.buildUrl(
      this.restApi.UPDATE_ROOT_CAUSE,
      { deviationId, rootCauseId }
    );

    return this.http.put<deviationInfo>(url, rootCause,{ headers: this.headers });
  }

  deleteRootCause(
    deviationId: number,
    rootCauseId: string
  ): Observable<deviationInfo> {

    const url = this.buildUrl(
      this.restApi.DELETE_ROOT_CAUSE,
      { deviationId, rootCauseId }
    );

    return this.http.delete<deviationInfo>(url,{ headers: this.headers });
  }

  // ===================== CAPA =====================

  getCapas(deviationId: any): Observable<Capa[]> {
    const url = this.buildUrl(
      this.restApi.GET_CAPAS_BY_DEVIATION_ID,
      { deviationId }
    );
    return this.http.get<Capa[]>(url,{ headers: this.headers });
  }

  addCapas(
    deviationId: any,
    capas: Capa[]
  ): Observable<deviationInfo> {

    const url = this.buildUrl(
      this.restApi.ADD_CAPAS,
      { deviationId }
    );

    return this.http.post<deviationInfo>(url, capas,{ headers: this.headers });
  }

  updateCapa(
    deviationId: number,
    capaId: string,
    capa: Capa
  ): Observable<deviationInfo> {

    const url = this.buildUrl(
      this.restApi.UPDATE_CAPA,
      { deviationId, capaId }
    );

    return this.http.put<deviationInfo>(url, capa,{ headers: this.headers });
  }

  deleteCapa(
    deviationId: number,
    capaId: string
  ): Observable<deviationInfo> {

    const url = this.buildUrl(
      this.restApi.DELETE_CAPA,
      { deviationId, capaId }
    );

    return this.http.delete<deviationInfo>(url,{ headers: this.headers });
  }

    getALLDeviations(): Observable<any[]> {
    const url = this.restApi.GET_ALL_DEVIATIONS;
    return this.http.get<any[]>(url,{ headers: this.headers });
  }

  getDeviationDetails(id: number): Observable<any> {
    const url = this.buildUrl(this.restApi.GET_DEVIATION_DETAILS, { id });
    return this.http.get<any>(url, { headers: this.headers });
  }

    getDeviationMetaData(id: number): Observable<any> {
    const url = this.buildUrl(this.restApi.GET_DEVIATION_METADATA, { id });
    return this.http.get<any>(url, { headers: this.headers });
  }



}
